import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { RequireAppView, RequireAnyAppView } from './RequireAppView';
import { ACCOUNT_TAB_APP_VIEW_IDS, SURVEYS_TAB_APP_VIEW_IDS } from '../permissions/canAccess';
import DefaultLandingRedirect from './DefaultLandingRedirect';
import { AppViewIds } from '../permissions/appViewIds';
import ManageAccount from '../views/account';
import UploadPage from '../views/upload';
import Videos from '../views/instructions';
// import Contact from '../views/contact';
import LicenseAgreement from '../views/LicenseAgreement';
import PolicyPage from '../views/policies/PolicyPage';
import { COOKIE_POLICY_PATH, PRIVACY_POLICY_PATH } from './LegalLinks';
import ProcessorSearch from '../views/processorSearch/ProcessorSearch';
import CustomersPage from '../views/customers/CustomersPage';
import PDFUploadPage from '../views/upload/PDFUploadPage';
import MessagePage from '../views/Messages/MessagePage';
import EstimatesFromMeTable from '../views/billing/EstimatesFromMeTable';
import EstimatesToMeTable from '../views/billing/EstimatesToMeTable';
import CompanyViewer from '../views/company/CompanyViewer';
import LicensingPage from '../views/licensing/LicensingPage';
import RulerPage from '../views/rulers/RulerPage';
import BotmarkEstimateTable from '../views/billing/BotmarkEstimateTable';
import AdminConfig from '../views/adminConfig/adminConfig';
import AppManagement from '../views/appManagement/AppManagement';
import AppDownload from '../views/appManagement/AppDownload';
import { SurveyPage } from '../views/surveys/SurveyPage';
import PlanPage from '../views/plans';
import PlanInboxTable from '../views/plans/PlanInboxTable';

function wrap(appViewId, element) {
    return (
        <RequireAppView appViewId={appViewId}>
            {element}
        </RequireAppView>
    );
}

export default function AppAuthenticatedRoutes() {
    return (
        <Routes>
            <Route path="/" element={<DefaultLandingRedirect />} />
            <Route path="/planInbox" element={wrap(AppViewIds.PlanInbox, <PlanInboxTable />)} />
            <Route path="/upload" element={wrap(AppViewIds.Upload, <UploadPage />)} />
            <Route path="/surveys" element={<RequireAnyAppView appViewIds={SURVEYS_TAB_APP_VIEW_IDS}><SurveyPage /></RequireAnyAppView>} />
            <Route path="/InvoicesToMe" element={wrap(AppViewIds.ReceivedEstimates, <EstimatesToMeTable />)} />
            <Route path="/CustomerEstimates" element={wrap(AppViewIds.CustomerEstimates, <EstimatesFromMeTable />)} />
            <Route path="/findProcessor" element={wrap(AppViewIds.FindProcessor, <ProcessorSearch />)} />
            <Route path="/customers" element={wrap(AppViewIds.Customers, <CustomersPage />)} />
            <Route path="/contacts" element={wrap(AppViewIds.Contacts, <MessagePage />)} />
            <Route path="/instructions" element={wrap(AppViewIds.Instructions, <Videos />)} />
            <Route path="/AppDownload" element={wrap(AppViewIds.AppDownload, <AppDownload />)} />
            <Route path="/account" element={<RequireAnyAppView appViewIds={ACCOUNT_TAB_APP_VIEW_IDS}><ManageAccount /></RequireAnyAppView>} />
            {/* <Route path="/contact" element={wrap(AppViewIds.Contact, <Contact />)} /> */}
            <Route path="/licenseAgreement" element={<LicenseAgreement />} />
            <Route path={PRIVACY_POLICY_PATH} element={<PolicyPage type="privacy" />} />
            <Route path={COOKIE_POLICY_PATH} element={<PolicyPage type="cookies" />} />
            <Route path="/companiesViewer" element={wrap(AppViewIds.CompaniesViewer, <CompanyViewer />)} />
            <Route path="/Configuration" element={wrap(AppViewIds.Configuration, <AdminConfig />)} />
            <Route path="/RulerCreator" element={wrap(AppViewIds.RulerCreator, <RulerPage />)} />
            <Route path="/licensing" element={wrap(AppViewIds.Licensing, <LicensingPage />)} />
            <Route path="/BotmarkInvoiceTable" element={wrap(AppViewIds.BotmarkInvoiceTable, <BotmarkEstimateTable />)} />
            <Route path="/AppManagement" element={wrap(AppViewIds.AppManagement, <AppManagement />)} />
            <Route path="/PDFupload" element={wrap(AppViewIds.PdfUpload, <PDFUploadPage />)} />
            <Route path="/plans" element={wrap(AppViewIds.Plans, <PlanPage />)} />
            <Route path="*" element={<DefaultLandingRedirect />} />
        </Routes>
    );
}
